/*

Routes:

Loads Creek station content with a front-end JS router.

TODO:

- Router must be able to interact with other Vue Routers that are instantiated on the DOM. Encapsulate the render or router object below somehow?

CONCERNS: 

How do I keep the Creek object accessible to modules?

- It's attached to the window, so just use it.

But what about options that are used later?

- Then use the data in the Creek object stored in the Vue VM, the $Station app

However, it doesn't yet exist when this script fires...

*/

import VueRouter from 'vue-router';

// Public npm stuff
var $ = require('jquery');

// Local stuff
var util = require('./creek-util');

// Debug must be manually initialized because creek-shows-router.js 
// is loaded outside of Creek.init()
var debug = require('./creek-debug').init({ debug: true }).log;
// var debug = require('./creek-debug').init().log;

//Shorthand
var containerSelectorString = Creek.data.shows.container;

//Set up shorthand for remote API base URL
var baseURLForAPI = Creek.data.content.baseURLForAPI;

//Set up components
var components = require('./creek-shows-components');

debug("Router: Loaded Shows Router JS file.");

//-------------------------------------------
// !!! TODO: RANDOM CODE TO ORGANIZE
//-------------------------------------------

//For the search bar on Archives page.
Vue.filter('notEmpty', function (value, input) {
  // here `input` === `this.userInput`
  return value + input;
})

//-------------------------------------------
// Actual router flow starts here
//-------------------------------------------

//!!! Remove this since we are now using it in creek-build.js
// window.VueRouter = require('vue-router');

//Add Vue Router to the global Vue instance
Vue.use(VueRouter);

//Initialize its routes
Creek.routes = [
  {
    path: '/weekday/:weekday_number',
    component: components['creek-page-shows']
  },
  {
    path: '/',
    component: components['creek-page-shows']
  },
  {
    path: '/profiles/:username',
    component: components['creek-page-profile']
  },
  {
    path: '/broadcasts/:broadcast_id',
    component: components['creek-page-broadcast']
  },
  {
    path: '/schedule',
    component: components['creek-page-shows-schedule']
  },
  {
    path: '/calendar',
    component: components['creek-page-shows-calendar']
  },
  {
    path: '/all',
    component: components['creek-page-shows-all']
  },
  // {
  //   path: '/archives',
  //   component: require('./creek-archives').init(Creek, Vue)
  // },
  {
    path: '/view/:short_name',
    component: components['creek-page-show']
  },
  {
    path: '/shows/:short_name',
    component: components['creek-page-show']
  },
  {
    path: '/x/:short_name',
    component: components['creek-page-show']
  },
  {
    path: '/:short_name',
    component: components['creek-page-show']
  }
];


//Only build the router if Shows container is in the DOM
Creek.checkAndBuildShowsRouter = function(){

  debug("Router: Checking for Shows container.");

  if($(containerSelectorString).length > 0){

    //Add the <router-view> outlet/container for Vue Router
    // if it's not already present in the container.
    if($(containerSelectorString).find("router-view").length == 0){
      debug("Creating Vue Router component inside Shows container: <router-view></router-view>");
      $(containerSelectorString).html("<router-view></router-view>");
    }
    else{
      debug("Found Vue Router component inside Shows container: <router-view></router-view>");
    }

    //Make sure Vue Router is not already initialized
    if(Creek.router == null){

      debug("Router: Building Router (because it's not already built).");

      //Initialize the router object
      Creek.router = new VueRouter({
        
        routes: Creek.routes,

        // This does nothing because it only works for the history router method.
        //
        // scrollBehavior (to, from, savedPosition){
        //   if (savedPosition) {
        //     return savedPosition;
        //   } else {
        //     return { x: 0, y: 0 }
        //   }
        // },

      })

      // Do a few things after page is changed:
      //
      // - Scroll handling
      // - Update main windows URL
      //
      Creek.router.afterEach((to, from) => {

        //Scroll to top of page on initial load, else scroll to top of Shows container
        if(to && to.path == "/" && from && from.path == "/"){
          $('html, body').scrollTop(0);
        }
        else{
          $('html, body').scrollTop( $(Creek.data.shows.container).offset().top + Creek.data.router.scrollOffset );
        }

        console.log("router");

        //Update main window URL if configured to do so
        if (Creek.data.persist.settings.iframe.forceUpdateURL) {
          var url = window.location.href;
          debug("Vue.js router: changing main window URL to: "+url);
          window.parent.Creek.data.persist.instance.handleNewIframeURL();
          // window.parent.Creek.data.persist.instance.handleNewIframeURL(url);
        }

      })

      if (Creek.data.persist.enable && Creek.data.persist.type == "singlepage") {
        //Initialize the Shows router page in persistence mode.
        var $CreekShows = new Vue({
          el: containerSelectorString,
          router: Creek.router,
          created: function(){
            debug("Created Vue.js instance for Shows Router.");
            return true;
          }
        });
      }

    }


  }else{

    debug("Router: Shows container " + containerSelectorString + " is NOT present.");

    Creek.router = null;

  }

}


//Perform functions on page load
$(function(){

  //Persistence: SinglePage: Check for Shows container each time
  if(Creek.data.persist.enable && Creek.data.persist.type == "singlepage"){

    debug("Shows + Router: Adding shows builder to onCompleteArray");

    Creek.data.persist.settings.singlepage.onCompleteArray.push(Creek.checkAndBuildShowsRouter);

    Creek.checkAndBuildShowsRouter();

  }
  //Persistence: iframe: Do nothing.
  else if(Creek.data.persist.enable && Creek.data.persist.type == "iframe"){
    
    //iframe code will handle Vue Router initialization when it is ready.

  }else{

    Creek.checkAndBuildShowsRouter();

  }

  //Check for container on the page.
  // if($(containerSelectorString).length < 1 && $("router-view").length < 1 ){
  //   debug("Warning: No container element for shows, nor an empty <router-view> element.");
  // }
  // else{
  //   debug("Shows container found: "+containerSelectorString);
  // }

});

//--------------------------------------------------------
// Convert this jQuery code to Vue later
//--------------------------------------------------------

// //When hovering on grouped show titles, move their respective images to be the first element in the image group container, so that CSS can show them
// $(document).on("hover", ".creek-show-group-title-link", function(){

//   //Set up vars
//   var show_id = $(this).attr("data-show-id");
//   var show_element = $(this).closest(".creek-show")
//   var image_group = show_element.find(".creek-grouped-image-container")
//   var grouped_image_element = image_group.find(".creek-grouped-image-"+show_id);

//   //Move the element
//   image_group.prepend(grouped_image_element);

// })



// WEBPACK FOOTER //
// ./src/creek-shows-router.js